import { connect } from 'react-redux'
import BgVideoComponent from "../components/BgVideoComponent";
import {loadCommonPopup,setWorkspaceTextFocus, nextBtnClicked, changeBg, dropBG,onItemDrag, changeVideoVolume} from '../actions/index';

const mapStateToProps = (state, ownProps) => ({
    selectedScene       :   state.localStore.get('selectedScene'),
    workspaceBG         :   state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG']),
    commonPopup         :   state.localStore.getIn(['commonPopup']),
    sceneDuration       :   state.project.getIn(['scenes',state.localStore.get('selectedScene'),'duration']),
    example             :   2,
    bgFilterCode        :   state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG', 'bgFilter']),
    isWorkspaceTextFocus: state.localStore.get('isWorkspaceTextFocus'),    
    selectedItems : state.localStore.get("selectedItems"),
    workspaceItems : state.project.getIn([ "scenes",state.localStore.get('selectedScene'), "workspaceItems"] ),
    workspaceCameras:  state.project.getIn([ "scenes",state.localStore.get('selectedScene'), "workspaceCameras"] ),
    bgVideoWidth : state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG', 'width']) ,
    bgVideoHeight:  state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG', 'height']),
    projectHeight: state.project.get("height"),
    projectWidth: state.project.get("width"),
    isBGVideoSwapinLite   : state.localStore.get("isBGVideoSwapinLite"),
    BgUndoData : state.localStore.get("undoProp")

})
         
  
const mapDispatchToProps = (dispatch, ownProps) => ({
    openCommonPopup     : (value, status)    =>{ 
        dispatch(loadCommonPopup(value, status))
    },
    setWorkspaceTextFocus:(data) => {
      dispatch(setWorkspaceTextFocus(data))
    },
    changeBg: (data, socket) => { dispatch(changeBg(data, socket)) },
    dropBG: (data, deleteData,socket) => {
        dispatch(dropBG(data, deleteData,socket))
      },
      onItemDrag:(socket, item,data,id,selItem, selectedScene) => {
        dispatch(onItemDrag(socket, item,data,id,selItem, selectedScene))
      },
      changeVideoVolume : (data, socket)=>{
        dispatch(changeVideoVolume(data, socket))
      },
      nextBtnClicked : (data) => {
        dispatch(nextBtnClicked(data))
      }
})
  
const BgVideo = connect(mapStateToProps,mapDispatchToProps)(BgVideoComponent)

export default BgVideo


// WEBPACK FOOTER //
// ./src/containers/BgVideo.js